/**
 * Converts a 1-based piece index to an alphabetic suffix (A�Z, then AA, AB, �).
 * Index 1 ? "A", 26 ? "Z", 27 ? "AA".
 */
export function getMultiPieceShipmentExtSuffix(pieceIndex: number): string {
  let n = pieceIndex;
  let suffix = '';

  while (n > 0) {
    n -= 1;
    suffix = String.fromCharCode(65 + (n % 26)) + suffix;
    n = Math.floor(n / 26);
  }

  return suffix;
}

/**
 * Builds the shipment ext shown on multi-piece airway bill labels.
 * Master piece keeps the base ext; linked pieces append A, B, � Z, AA, �
 */
export function buildMultiPieceShipmentExt(
  baseHawbExt: string,
  pageIndex: number
): string {
  if (pageIndex === 0) {
    return baseHawbExt;
  }

  return `${baseHawbExt}${getMultiPieceShipmentExtSuffix(pageIndex)}`;
}
